<template>
    <div class="error-page">
        <div class="content">
            <slot />
        </div>
        <img
            src="@/assets/images/not-working.png"
            class="not-working-image"
            alt="not working icon"
        >
    </div>
</template>

<style lang="scss" scoped>
    .error-page {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        background-color: #f3f3f3;
        height: 100vh;

        :deep(.content) {
            @include center-children;
            flex-direction: column;
            margin-top: 10vh;
            @include mq(max-width 1440px) {
                margin-top: 8vh;
            }
            @include mq(max-height 800px) {
                margin-top: 8vh;
            }

            .title {
                font-size: 100px;
                display: block;
                font-weight: 900;
                color: rgb(241, 90, 93);
                text-transform: uppercase;
                line-height: 1.2;
                text-align: left;
                @include mq(max-width 1440px) {
                    font-size: 60px;
                }
                @include mq(max-height 800px) {
                    font-size: 60px;
                }
                &.second {
                    font-size: 90px;
                    margin-top: 10px;
                    font-weight: 700;
                    @include mq(max-width 1440px) {
                        font-size: 50px;
                    }
                    @include mq(max-height 800px) {
                        font-size: 50px;
                    }
                    @include mq(max-width 769px) {
                        font-size: 20px;
                    }
                }

                &.second-without-text-transform {
                    text-transform: none;
                }

            }

            .description {
                color: rgb(144, 144, 144);
                font-size: 22px;
                line-height: 1.2;
                text-align: left;
                margin-top: 10px;
                @include mq(max-width 1440px) {
                    font-size: 18px;
                }
                @include mq(max-height 800px) {
                    font-size: 18px;
                }
            }

            .button {
                @include center-children;
                background-image: linear-gradient(-45deg, rgb(61, 146, 235) 0%, rgb(19, 95, 160) 100%);
                width: 215px;
                height: 60px;
                border-radius: 31.5px;
                margin-top: 25px;
                cursor: pointer;
                z-index: 999;
                @include mq(max-width 1440px) {
                    width: 180px;
                    height: 45px;
                }
                @include mq(max-height 800px) {
                    width: 180px;
                    height: 45px;
                }

                .button-content {
                    @include space-between;

                    img {
                        width: 19px;
                        transform: rotate(90deg);
                        opacity: .8;
                    }

                    .button-title {
                        font-size: 16px;
                        color: rgb(255, 255, 255);
                        margin-left: 10px;
                    }
                }
            }
        }

        :deep(.not-working-image) {
            position: absolute;
            width: 100%;
            bottom: 10%;
            @include mq(max-width 1440px) {
                bottom: 8%;
            }
            @include mq(max-height 800px) {
                bottom: 8%;
            }
            @include mq(max-height 600px) {
                bottom: 6%;
            }
            @include mq(max-width 769px) {
                bottom: 20%;
            }
        }

    }
</style>


